<template>
  <base-form :title="$route.params.id ? $t('vouchers.form.edit') : $t('vouchers.form.create')" :loading="loading" @submit="onSubmit">
    <div class="row">
      <div class="col-12">
        <fg-input :name="$t('vouchers.form.code')"
                  :placeholder="$t('vouchers.form.code')"
                  :label="$t('vouchers.form.code')"
                  v-model="model.code"
                  :error="getError($t('vouchers.form.code'))"
                  :required="$route.params.id">

        </fg-input>
        <fg-input :error="getError($t('vouchers.form.discount_type'))"
                  :label="$t('vouchers.form.discount_type')"
                  required>
          <el-select class="select-default"
                     :name="$t('vouchers.form.discount_type')"
                     :placeholder="$t('vouchers.form.discount_type')"
                     :error="getError($t('vouchers.form.discount_type'))"
                     v-model="model.discount_type"
                     filterable
                     v-validate="'required'"
                     required
                     clearable>
            <el-option class="select-default"
                       v-for="option in discountTypes"
                       :value="option.value"
                       :label="option.label"
                       :key="option.value">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input :name="$t('vouchers.form.discount_value')"
                  required
                  :placeholder="$t('vouchers.form.discount_value')"
                  :label="$t('vouchers.form.discount_value')"
                  v-model="model.discount_value"
                  type="number"
                  v-validate="'required|numeric|max_discount_value:' + model.discount_type"
                  :error="getError($t('vouchers.form.discount_value'))">
        </fg-input>
        <fg-input :name="$t('vouchers.form.usage_limit')"
                  :placeholder="$t('vouchers.form.usage_limit')"
                  :label="$t('vouchers.form.usage_limit')"
                  v-model="model.usage_limit"
                  :error="getError($t('vouchers.form.usage_limit'))">
        </fg-input>
        <fg-input :placeholder="$t('vouchers.form.expires_at')"
                  :label="$t('vouchers.form.expires_at')"
                  :name="$t('vouchers.form.expires_at')"
                  :add-form-control-class="false"
                  :error="getError($t('vouchers.form.expires_at'))"
                  component="el-date-picker"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="model.expires_at">
        </fg-input>
        <fg-input :label="$t('generic.client')"
                  :error="getError($t('generic.client'))">
          <client-autocomplete
                  v-model="client"
                  :client="client"
                  :allow-create="false"
                  :clearable="true"
                  :name="$t('generic.client')"
                  @change="onClientChange">
          </client-autocomplete>
        </fg-input>
        <fg-input
                  v-model="model.minimum_purchase_amount"
                  :name="$t('vouchers.form.minimum_purchase_amount')"
                  :placeholder="$t('vouchers.form.minimum_purchase_amount')"
                  :label="$t('vouchers.form.minimum_purchase_amount')"
                  v-validate="'numeric|min_value:0'"
                  :error="getError($t('vouchers.form.minimum_purchase_amount'))">
        </fg-input>
        <fg-input :label="$t('generic.product')"
                  :error="getError($t('generic.product'))">
          <product-multi-select
                  :placeholder="$t('generic.product')"
                  :clearable="true"
                  :value="model.restricted_to_products"
                  @change="model.restricted_to_products = $event"
                  :options="allProducts"
                  :name="$t('generic.product')">
          </product-multi-select>
        </fg-input>
      </div>
    </div>
  </base-form>
</template>

<script>
  import { Select, Option } from 'element-ui';
  import ClientAutocomplete from 'src/components/Autocomplete/ClientAutocomplete';
  import { discountType } from "../../../../config/voucherEnums";
  import { DatePicker } from 'element-ui';
  import Vue from "vue";
  import { mapGetters } from "vuex";
  import ProductMultiSelect from 'src/components/Autocomplete/ProductMultiSelect';


  Vue.use(DatePicker);

  export default {
    name: 'voucher-form',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ClientAutocomplete,
      ProductMultiSelect
    },
    props: {
      loading: Boolean,
      post: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        formTitle: this.$t('vouchers.form.formTitle'),
        client: null,
        model: {
          code: '',
          discount_type: '',
          discount_value: null,
          usage_limit: 1,
          expires_at: null,
          client_id: null,
          minimum_purchase_amount : null,
          restricted_to_products : [],
        },
      }
    },
    methods: {
      onClientChange(val) {
        this.client = val;
        this.model.client_id = val ? val.uuid : null;
      },
      async onSubmit() {
        let valid = await this.$validator.validateAll();
        if (valid) {
          this.$emit('submit', this.model);
        }
      }
    },
    computed: {
      ...mapGetters('config', ['allProducts']),
      discountTypes() {
        return Object.keys(discountType).map(key => {
          let value = discountType[key];
          return {
            label: this.$t(`vouchers.discountTypes.${value}`),
            value
          }
        });
      },
      isCodeRequired() {
        return window.location.pathname.includes('edit');
      },
    },
    watch: {
      post: {
        immediate: true,
        handler: function(newVal) {
          if (newVal) {
            this.model = newVal;
            this.model.minimum_purchase_amount = newVal.restrictions.minimum_purchase_amount ? parseFloat(newVal.restrictions.minimum_purchase_amount) : null;

            this.model.restricted_to_products = newVal.restrictions.restricted_to_products ? newVal.restrictions.restricted_to_products : [];
            this.client = newVal.client;
          }
        }
      },
    },
  }
</script>